export enum Gender {
    Male = 1,
    Female,
    Ohter
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/common/enum.ts